import { gql } from '@apollo/client';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import CardContainer from '../CardContainer/CardContainer.pim';
import CardSection from '../ContentSystem/components/CardSection/CardSection';
import ContentBlock from '../ContentBlock/ContentBlock.pim';
import HeaderSection from '../ContentSystem/components/HeaderSection/HeaderSection';
import ImageSection from '../ContentSystem/components/ImageSection/ImageSection';
import ProductDetails from './components/ProductDetails/ProductDetails';
import ResponsiveContainer from '../ResponsiveContainer.pim/ResponsiveContainer';
import TextBlock from '../ContentfulTextBlock/ContentfulTextBlock.pim';
import TextSection from '../ContentSystem/components/TextSection/TextSection';

export const PRODUCT_PAGE = gql`
  query ProductPage(
    $path: String!
    $preview: Boolean
    $overrides: FeatureFlags
  ) {
    page(path: $path, preview: $preview, overrides: $overrides) {
      id
      publishPageIndexed
      sections {
        ... on Product {
          categories
          collections
          id
          url
          title
          description
          externalSystems {
            shopify
          }
          tags
          attributes {
            activities
            hasCompression
            hasPocket
            hasGripper
            sockHeight
            sockWeight
            endUse
            neckCollarType
            cut
            sleeveLength
            material
            uwCoverage
            waistRise
          }
        }
        ...BreadcrumbsFragment
        ...CardContainerFragment
        ...CardSectionFragment
        ...ContentBlockFragment
        ...HeaderSectionFragment
        ...ImageSectionFragment
        ...ProductDetailsFragment
        ...ResponsiveContainerFragment
        ...TextBlockFragment
        ...TextSectionFragment
      }
    }
  }
  ${Breadcrumbs.fragment}
  ${CardContainer.fragment}
  ${CardSection.fragment}
  ${ContentBlock.fragment}
  ${HeaderSection.fragment}
  ${ImageSection.fragment}
  ${ProductDetails.fragment}
  ${ResponsiveContainer.fragment}
  ${TextBlock.fragment}
  ${TextSection.fragment}
`;

export const PRODUCT = gql`
  query Product($id: ID!) {
    product(id: $id) {
      categories
      id
      url
      title
      description
      externalSystems {
        shopify
      }
      tags
      ...ProductDetailsFragment
      ...BreadcrumbsFragment
    }
  }
  ${Breadcrumbs.fragment}
  ${ProductDetails.fragment}
`;

export const QBS_DISCOUNT_DATA = gql`
  query QbsDiscountData {
    qbsDiscountData {
      id
      decisionTree
      decisionKeys
      parsedDecisionTree
      discountTier
      excludedSkus
      includedSkus
      parsedIncludedSkus
      groupBy
    }
  }
`;

export default {};
